import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfo = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M512 0c-282.624 0-512 229.376-512 512s229.376 512 512 512c282.624 0 512-229.376 512-512s-229.376-512-512-512zM512 768c-28.16 0-51.2-23.040-51.2-51.2v-204.8c0-28.16 23.040-51.2 51.2-51.2s51.2 23.040 51.2 51.2v204.8c0 28.16-23.040 51.2-51.2 51.2zM563.2 358.4h-102.4v-102.4h102.4v102.4z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgInfo);
export default ForwardRef;
